<script setup lang="ts">
export type EllipseVariant = 'primary' | 'accent'

interface EllipseProps {
  variant?: EllipseVariant
}
withDefaults(defineProps<EllipseProps>(), {
  variant: 'primary',
})
</script>

<template>
  <div absolute h="md:160% 150%" w="md:160% 150%" top="md:-30% -25%" left="md:-30% -25%" rounded-full>
    <NuxtImg absolute w-full h-full dark:opacity-50 rounded-full opacity-70 :src=" variant === 'primary' ? '/img/ellipse-blue.webp' : '/img/ellipse-accent.webp'" alt="" z-5 />
  </div>
</template>
